import env from 'react-dotenv';
import { initializeApp } from 'firebase/app';
//import { getAuth } from 'firebase/auth';
import { getStorage, ref } from 'firebase/storage';
import RestServices from '../services/RestServices.js';

const firebaseConfigProd = {
    apiKey: 'AIzaSyACAhE8CDkoiLhwbDP5Zr_bIcImYz4Hs1Y',
    authDomain: 'app.indiabuys.co',
    databaseURL: 'https://indiabuys-project.firebaseio.com',
    projectId: 'indiabuys-project',
    storageBucket: 'indiabuys-project.appspot.com',
    messagingSenderId: '808596230565',
    appId: '1:808596230565:web:a94d1fc22bae1f26a7984c',
    measurementId: 'G-1TJHPFT5CH'
};

const firebaseConfigDev = {
    apiKey: "AIzaSyAsyasXVe_xCHyZAy_IgtNyQAQKKe7ohoU",
	authDomain: "dev-indiabuys.firebaseapp.com",
	projectId: "dev-indiabuys",
	storageBucket: "dev-indiabuys.appspot.com",
	messagingSenderId: "91314239844",
	appId: "1:91314239844:web:74e1d17833e4ab73572271",
	measurementId: "G-79SPJFWLY9"
};

//const firebaseConfig =firebaseConfigProd // Live
const firebaseConfig =firebaseConfigDev  // Dev
   

class Firebase {
    constructor() {
        this.app = initializeApp(firebaseConfig);
       // this.auth = getAuth(this.app);
        this.storage = getStorage(this.app);
        this.storageRef = ref(this.storage);
    }

    doSignOut = async () => {
        //await this.auth.signOut();
        let dataRow = {
            FirebaseToken: localStorage.getItem('FirebaseToken')
        };
        RestServices.doLogOut( dataRow )
            .then((response) => response.json())
            .then(async (responseData) => {
                localStorage.clear();
                window.location.replace('signin');
                window.dispatchEvent(new Event("storage"));
                this.toggleMenu();
            })
        
    };

    doSignOutRelogin = async () => {
        let dataRow = {
            FirebaseToken: localStorage.getItem('FirebaseToken')
        };
        RestServices.doLogOut( dataRow )
            .then((response) => response.json())
            .then(async (responseData) => {
        if (
            localStorage.getItem('WitchloginAs') &&
            localStorage.getItem('WitchloginAs') != ''
        ) {
            let WitchloginAs = localStorage.getItem('WitchloginAs');
            localStorage.clear();
            localStorage.setItem('WitchloginAs', WitchloginAs);
        } else {
            localStorage.clear();
        }
        window.dispatchEvent(new Event("storage"));
        window.location.replace('signin');
        this.toggleMenu();

        })
    };

    openDropDown = (event) => {
        const allWithClass = Array.from(document.querySelectorAll('li.isOpen'));
        allWithClass.forEach((element) => {
            element.classList.remove('isOpen');
        });
        event.currentTarget.classList.add('isOpen');
    };

    toggleMenu = () => {
        const allWithClass = Array.from(
            document.querySelectorAll('.sidebar-menu')
        );
        allWithClass.forEach((element) => {
            element.classList.toggle('isOpen');
        });
    };

    switchLoginAs = (event) => {
        const allWithClass = Array.from(
            document.querySelectorAll('.top-menu li.dropdown_menu')
        );
        allWithClass.forEach((element) => {
            element.classList.toggle('isOpen');
        });
    };

    switchLoginAsTo = (LoginAs) => {
        localStorage.setItem('WitchloginAs', LoginAs);

        const allWithClass = Array.from(
            document.querySelectorAll('.top-menu li.dropdown_menu')
        );
        allWithClass.forEach((element) => {
            element.classList.toggle('isOpen');
        });
        window.location.replace('/');
        this.toggleMenu();
    };
}

export default Firebase;
